/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An area chart is a line chart with the region beneath each line shaded. The fill emphasises the size of the values and the cumulative sense of volume over the axis.`)
};

const es_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un gráfico de área es un gráfico de líneas con la región debajo de cada línea sombreada. El relleno resalta el tamaño de los valores y la sensación acumulada de volumen a lo largo del eje.`)
};

const de_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Flächendiagramm ist ein Liniendiagramm, bei dem der Bereich unter jeder Linie schattiert ist. Die Füllung betont die Größe der Werte und den kumulativen Eindruck des Volumens über die Achse.`)
};

const nl_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een vlakdiagram is een lijndiagram waarbij het gebied onder elke lijn is gearceerd. De vulling benadrukt de grootte van de waarden en het cumulatieve gevoel van volume over de as.`)
};

const fr_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un graphique en aires est un graphique en courbes dont la région sous chaque courbe est ombrée. Le remplissage met en valeur la taille des valeurs et le sens cumulatif du volume le long de l'axe.`)
};

const it_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un grafico ad area è un grafico a linee con la regione sotto ciascuna linea ombreggiata. Il riempimento enfatizza la dimensione dei valori e il senso cumulativo di volume lungo l'asse.`)
};

const pt_br2_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um gráfico de área é um gráfico de linhas com a região abaixo de cada linha sombreada. O preenchimento enfatiza o tamanho dos valores e a sensação cumulativa de volume ao longo do eixo.`)
};

const pt_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um gráfico de área é um gráfico de linhas com a região abaixo de cada linha sombreada. O preenchimento realça a dimensão dos valores e a noção cumulativa de volume ao longo do eixo.`)
};

const ja_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エリアチャートは、各線の下の領域を塗りつぶした折れ線グラフです。塗りつぶしにより値の大きさと軸全体にわたる累積的な量の感覚が強調されます。`)
};

const zh_area_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`面积图是在每条线下方区域填色的折线图。填充色突出了数值的大小以及在坐标轴上累积的量感。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_faq_a1", locale)
	if (locale === "en") return en_area_faq_a1(inputs)
	if (locale === "es") return es_area_faq_a1(inputs)
	if (locale === "de") return de_area_faq_a1(inputs)
	if (locale === "nl") return nl_area_faq_a1(inputs)
	if (locale === "fr") return fr_area_faq_a1(inputs)
	if (locale === "it") return it_area_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_area_faq_a1(inputs)
	if (locale === "pt") return pt_area_faq_a1(inputs)
	if (locale === "ja") return ja_area_faq_a1(inputs)
	return zh_area_faq_a1(inputs)
};